module.exports = __webpack_public_path__ + "img/info_banner3.363c4fd.jpg";